import React from 'react'
import PropTypes from 'prop-types'
import { t } from '../../translation'

import Slider from '../ui/Input/Slider/Slider'
import { secToMin } from '../../utils/conversion'

const PlayerDurationSlider = ({
  selectedDuration,
  changeDurationHandler,
  min,
  max,
  disabled,
  ...props
}) => {
  // Label for aria
  const durationSliderLabel = 'durationSliderLabel'
  const selectedDurationMinutes = secToMin(selectedDuration)

  return (
    <div className="player_duration_timeline_wrap">
      <div className="player_duration_timeline_list">
        <div className="player_duration_timeline_label" id={durationSliderLabel}>
          {t('player.APPROXIMATE_DURATION')}:
        </div>
        <button
          className="player_duration_timeline_btn v1_mod"
          disabled={disabled}
          onClick={() => {
            selectedDurationMinutes > min
              ? changeDurationHandler(selectedDurationMinutes - 5)
              : ''
          }}
        ></button>
        <div className="player_duration_timeline_time">
          {selectedDurationMinutes} {t('player.MINUTES')}
        </div>
        <button
          className="player_duration_timeline_btn v2_mod"
          disabled={disabled}
          onClick={() => {
            selectedDurationMinutes < max
              ? changeDurationHandler(selectedDurationMinutes + 5)
              : ''
          }}
        ></button>
      </div>
      {/* <Slider
        {...props}
        initialValue={secToMin(initialValue)}
        min={15}
        max={90}
        ariaLabelId={durationSliderLabel}
      /> */}
    </div>
  )
}

export default PlayerDurationSlider

// PlayerDurationSlider.propTypes = {
//   initialValue: PropTypes.number.isRequired,
//   selectedDuration: PropTypes.number.isRequired,
// }
